import { isServer } from '@/utils/util';
import { UAParser } from 'ua-parser-js';
import packageInfo from '../../../package.json';

export const getCommonHeaders = () => {
  const headers: Record<string, string> = {
    // 필수 헤더
    'Content-Type': 'application/json',

    // 언어 및 지역
    'X-Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    'Accept-Language': 'ko-KR',

    // 클라이언트 정보
    'X-Client-Type': 'web',
    'X-Client-Version': packageInfo?.version ?? 'unknown',
  };

  if (!isServer()) {
    const parser = new UAParser(window.navigator.userAgent);
    const browser = parser.getBrowser();
    const os = parser.getOS();
    const device = parser.getDevice();

    headers['X-Browser-Type'] = browser.name?.toLowerCase() || 'unknown';
    headers['X-Browser-Version'] = browser.version || 'unknown';

    // Device, OS 정보
    headers['X-Mobile-Web'] = String(device.type === 'mobile');
    headers['X-OS-Type'] = os.name?.toLowerCase() || 'unknown';
    headers['X-OS-Version'] = os.version || 'unknown';
  }

  return headers;
};

export const generateHeaders = () => {
  const headers: Record<string, string> = {};
  // 요청 고유 ID
  headers['X-Request-Id'] = crypto.randomUUID();

  if (isServer()) {
    return headers;
  }

  const parser = new UAParser(window.navigator.userAgent);
  const device = parser.getDevice();

  const cllientHeaders: Record<string, string> = {
    // 언어 및 지역
    'Accept-Language': window.navigator.language || 'ko-KR',

    // 화면 정보
    'X-Screen-Size': `${window.screen.width}x${window.screen.height}`,
    'X-Window-Size': `${window.innerWidth}x${window.innerHeight}`,
  };

  // 모바일 기기인 경우에만 추가 정보 포함
  if (device.type === 'mobile') {
    cllientHeaders['X-Device-Model'] = device.model || 'unknown';
    cllientHeaders['X-Device-Id'] = getDeviceId();
  }

  return { ...headers, ...cllientHeaders };
};

// 디바이스 ID 생성 및 저장
const getDeviceId = () => {
  const storageKey = 'device_id';
  let deviceId = localStorage.getItem(storageKey);

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(storageKey, deviceId);
  }

  return deviceId;
};
